import {Container, Text} from "pixi.js";
import {keyboard, Keyboard} from "./i.js"; // ./keyboard.js
import {UIUtils} from "./i.js"; // ./ui/utils.js
import {Space} from "./i.js"; // ./space.js
import {Tooltipper} from "./i.js"; // ./ui/tooltipper.js
import {Unicenter} from "./i.js"; // ./unicenter/unicenter.js
import {Dashboard} from "./i.js"; // ./dashboard/dashboard.js
import {Respawner} from "./i.js"; // ./respawner.js

export class Game extends Container {
	// Create a new game object
	// For now, this constructor takes no parameters, and always creates a new
	// game. In the future, this constructor will likely be able to both create
	// a new game and load an existing game from a savefile; in such a future,
	// this constructor will likely take a savefile as an optional parameter.
	constructor() {
		super();


		this.tooltipper = new Tooltipper(this);
		// Unicenter depends on the tooltipper
		this.unicenter = new Unicenter(this);
		// Space depends on the unicenter
		this.space = new Space(this);
		// Dashboard depends on the tooltipper
		this.dashboard = new Dashboard(this);
		this.respawner = new Respawner(this.space.player);

		this.addChild(this.space);
		this.addChild(this.dashboard.display);
		this.addChild(this.unicenter.display);
		this.addChild(this.respawner);
		this.addChild(this.tooltipper.display);

		this.winDisplay = new Text("", UIUtils.getFont(0xdddddd, {fontSize: 24}));
		this.winDisplay.anchor.set(0, 0);
		this.addChild(this.winDisplay);


		this.posDisplay = new Text("", UIUtils.getFont(0xdddddd, {fontSize: 24}));
		this.posDisplay.anchor.set(1, 1);
		this.addChild(this.posDisplay);

		// TODO: Move this display to a debug screen
		this.fpsDisplay = new Text("",
			UIUtils.getFont(0xdddddd, {fontSize: 16, align: "right"})
		);
		this.fpsDisplay.anchor.set(1, 0);
		this.addChild(this.fpsDisplay);

		this.averageFPS = [];

		// TODO: Pop this control when it's no longer needed
		keyboard.pushControl(new Keyboard.Control(
			"GAME",
			new Map([
				[".UNICENTER", "SHOW_UNICENTER"]
			]),
			new Set()
		));
	}

	// Advance the game by one frame
	// dt is the time since last update, in seconds. screenSize is a vector
	// containing the screen size, in pixels. fps is the number of frames per
	// second, as reported by PixiJS.
	update(dt, screenSize, fps) {
		if (keyboard.getActions("GAME").has("SHOW_UNICENTER")) {
			this.unicenter.show();
		}

		// The unicenter now handles upgrades and stuff, so update it first to
		// avoid a 1-tick delay on upgrades
		this.unicenter.update(dt, screenSize);
		this.respawner.update(screenSize);

		this.space.update(dt, screenSize);
		this.dashboard.update(dt, screenSize);
		this.tooltipper.update(dt, screenSize);

		this.winDisplay.text = this.unicenter.inventory
			.winnerWinnerChickenDinner() ? "You win!!!" : "";
		this.winDisplay.position.set(20, 20);
		if (this.space.player.pos != undefined)
			this.posDisplay.text = Math.floor(this.space.player.pos.x)
							+ "," + Math.floor(this.space.player.pos.y);
		this.posDisplay.position.set(screenSize.x - 20, screenSize.y - 20);

		this.averageFPS.unshift(fps);
		if (this.averageFPS.length > 256) this.averageFPS.pop();
		let averageFPSDisplay = Math.round(
			this.averageFPS.reduce((a, b) => a + b) / this.averageFPS.length
		);
		this.fpsDisplay.text = `${averageFPSDisplay}\n${this.space.things.length}`
						+ `\n${this.space.interactor._collisionCooldowns.size}`;
		this.fpsDisplay.position.set(screenSize.x - 20, 20);
	}

	// Save the state of the game into an object
	save() {
		// TODO
	}
}
